package com.fireavert.info.data_models

import kotlinx.serialization.Serializable

@Serializable
data class DeviceInfo(
    val deviceType: String = "",
    val unit: String = "",
    val propertyName: String = "",
)